import React from 'react';
import s from '../../styles/renewal/Hero.module.css';
import p from '../../styles/renewal/OnePage.module.css';
import { HERO_POINTS, HERO_STATS } from './data';

const Hero = ({ estimate, onNavigate }) => (
  <section className={s.hero}>
    <div className={s.stage}>
      <img
        className={s.bg}
        src={`${process.env.PUBLIC_URL}/renewal/hero-bg.webp`}
        alt=""
        aria-hidden="true"
      />
      <div className={s.scrim} />

      <div className={s.inner}>
        <div className={s.grid}>
          <div className={s.copy}>
            <div className={`${p.badge} ${p.badgeLight}`}>BUSINESS BNPL</div>

            <h1 className={s.h1}>
              <span>사업의 기회는 놓치지 않고,</span>
              <span>대금은 계획에 맞춰</span>
              <span>나누어 납부하세요.</span>
            </h1>

            <p className={s.sub}>
              오퍼그룹 BNPL은 사업자의 상황에 맞는 이용방식을 안내하고, 계약에 따라 대금을 나누어
              납부할 수 있도록 돕는 사업자 전용 서비스입니다.
            </p>

            <div className={s.points}>
              {HERO_POINTS.map((text) => (
                <div className={s.point} key={text}>
                  <span className={s.check} aria-hidden="true">
                    ✓
                  </span>
                  {text}
                </div>
              ))}
            </div>

            <div className={s.ctaRow}>
              <button
                type="button"
                className={`${p.btn} ${p.btnPrimary}`}
                onClick={() => onNavigate('contact')}
              >
                상담신청 →
              </button>
              <button
                type="button"
                className={`${p.btn} ${p.btnGhost}`}
                onClick={() => onNavigate('service')}
              >
                BNPL 알아보기 ↘
              </button>
            </div>
          </div>

          {/* 간이 견적 카드 */}
          <div className={s.quote}>
            <div className={s.quoteEyebrow}>QUICK ESTIMATE</div>
            <div className={s.quoteTitle}>예상 이용금액 확인</div>

            <label className={s.fieldLabel} htmlFor="hero-sales">
              월평균 온라인·카드매출
            </label>
            <div className={`${s.field} ${s.gapAfter}`}>
              <input
                id="hero-sales"
                className={s.input}
                value={estimate.salesVal}
                onChange={estimate.onSales}
                inputMode="numeric"
              />
              <span className={s.unit}>만원</span>
            </div>

            <div className={s.pair}>
              <div>
                <label className={s.fieldLabel} htmlFor="hero-annual">
                  작년 매출액
                </label>
                <div className={s.field}>
                  <input
                    id="hero-annual"
                    className={s.input}
                    value={estimate.annualVal}
                    onChange={estimate.onAnnual}
                    inputMode="numeric"
                  />
                  <span className={s.unit}>만원</span>
                </div>
              </div>
              <div>
                <label className={s.fieldLabel} htmlFor="hero-expense">
                  작년 매입·필요경비
                </label>
                <div className={s.field}>
                  <input
                    id="hero-expense"
                    className={s.input}
                    value={estimate.expenseVal}
                    onChange={estimate.onExpense}
                    inputMode="numeric"
                  />
                  <span className={s.unit}>만원</span>
                </div>
              </div>
            </div>

            <div className={s.result}>
              <div className={s.resultTop}>
                <div>
                  <div className={s.resultLabel}>예상 이용금액</div>
                  <div className={s.resultBig}>{estimate.limitLabel}</div>
                </div>
                <div>
                  <div className={s.resultLabel}>예상 납부기간</div>
                  <div className={s.resultMid}>{estimate.periodLabel}</div>
                </div>
              </div>

              <div className={s.resultRow}>
                <span className={s.resultRowLabel}>월 예상 납부금액</span>
                <span className={s.resultRowValue}>{estimate.useMonthLabel}</span>
              </div>

              <button
                type="button"
                className={`${p.btn} ${p.btnPrimary} ${s.quoteCta}`}
                onClick={() => onNavigate('contact')}
              >
                이 조건으로 상담신청 →
              </button>
            </div>

            <div className={s.disclaimer}>
              입력값에 따른 단순 예상이며, 실제 조건은 심사·계약에 따라 달라집니다.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className={p.statBar}>
      <div className={p.statGrid}>
        {HERO_STATS.map((stat) => (
          <div className={p.statCell} key={stat.label}>
            <div className={p.statValue}>{stat.value}</div>
            <div className={p.statLabel}>{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Hero;
